export default __webpack_public_path__ + "static/media/bank-mandiri.6e99a526.png";